import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/7eb7dd7b/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ComponentStatus from 'components/ComponentStatus';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentStatus mdxType="ComponentStatus" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      